
import iconWhiteCall from "../../../Icons/NV/white/call.png";
import iconWhiteWhatsApp from "../../../Icons/NV/white/whatsApp.png";

import iconBack from "../../../Icons/icons-white/back.png";
import iconForward from "../../../Icons/NV/white/forward-img.png";

import GENRALHELPERS from "../GENRAL-HELPERS";
import homeScreen from "../home-screen/home-screen";

class generateHtml {

  _NVGenerateSeller(data, businessHtml, listingsHtml) {

    let sellerLevel = data.sellerLevel || 'standart';
    sellerLevel = 'standart'; // just gaurd for now, to later get seller levels in place

    let proLevelDataDisp = 'none';

    let about = data.aboutMe || 'Vendedor en Mercado MAI.';

    let profileImageUrl =
      data?.profileImages?.[0]?.res_200 ?? data?.profileImageUrl;

    let origImg = []
    origImg.push(data?.profileImages?.[0]?.res_1000 ?? data?.profileImageUrl)

    let listingsNum = data?.numberOfListings || 0;



    let sellerLevelBackgroundClass = ''
    let sellerLevelText1Class = ''
    let sellerLevelText2Class = ''
    let sellerLevelStandartClass = ''

    let sellerLevelText1 = ''
    let sellerLevelText2 = ''

    if (sellerLevel === 'gold') {
      proLevelDataDisp = 'flex';
      sellerLevelBackgroundClass = 'sellerLevelGold';
      sellerLevelText1 = 'Vendedor nivel ORO'
      sellerLevelText2 = 'Mercado MAI recomienda este vendedor por publicar frecuentemente.'
    } else if (sellerLevel === 'silver') {
      proLevelDataDisp = 'flex';
      sellerLevelBackgroundClass = 'sellerLevelSilver';
      sellerLevelText1 = 'Vendedor nivel PLATA'
      sellerLevelText2 = 'Mercado MAI recomienda este vendedor por su esfuerzo de subir nuevas publicaciones.'
    } else if (sellerLevel === 'reported') {
      proLevelDataDisp = 'flex';
      sellerLevelBackgroundClass = 'sellerLevelReported';
      sellerLevelText1Class = 'sellerLevelReportedText1';
      sellerLevelText2Class = 'sellerLevelReportedText2';
      sellerLevelText1 = 'Vendedor REPORTADO'
      sellerLevelText2 = 'Mercado MAI no recomienda este vendedor por tener reportes negativos de nuestros usuarios.'
    } else {
      sellerLevelStandartClass = 'nvSellerProfileCon1Standart';
    }

    const sellerHtml = `
        
          <div data-sellerid="${data.userId}" class="ActionOpenForDisplaySeller nvSellerProfileCon1 ${sellerLevelStandartClass}">
            <div class="nvSellerProfileCon2">
              <div class="nvSellerProfileCon3 ${sellerLevelBackgroundClass}">
                <img data-origimg="${origImg.join("°-°|°-°?°-°|°-°")}" class="nvSellerProfileCon3Image ImgForBigDisplay hasOriginalImages" src="${profileImageUrl}">
              </div>
              <div class="nvSellerProfileCon4">
                <div class="nvSellerProfileCon5">
                  <div class="nvSellerProfileText1">${data.userName}</div>
                </div>
                <div class="nvSellerProfileCon6">
                  <div class="nvSellerProfileText4">${about}</div>
                </div>
              </div>
            </div>
            <div class="nvSellerProfileCon7A">
              <div class="nvSellerProfileCon7">
                <div class="nvSellerProfileCon11">
                  <div class="nvSellerProfileText3">Datos sobre este vendedor</div>
                </div>
                <div class="nvSellerProfileCon8">
                  <div class="nvSellerProfileCon9">
                    <div class="nvSellerProfileText4">Registrado desde</div>
                    <div class="nvSellerProfileText5">${GENRALHELPERS._convertServerTimestampToReadableTime(data.createdAt, false)}</div>
                  </div>
                  <div class="nvSellerProfileCon9" style="display: none">
                    <div class="nvSellerProfileText4">Publicaciones</div>
                    <div class="nvSellerProfileText5">${listingsNum}</div>
                  </div>
                  <div class="nvSellerProfileCon9">
                    <div class="nvSellerProfileText4">Numero de WhatsApp</div>
                    <div class="nvSellerProfileText5">${data.callNumber}</div>
                  </div>
                  <div class="nvSellerProfileCon9">
                    <div class="nvSellerProfileText4">Numero de llamadas</div>
                    <div class="nvSellerProfileText5">${data.whatsAppNumber}</div>
                  </div>
                </div>
              </div>
              <div class="nvSellerProfileCon13" style="display: ${proLevelDataDisp}">
                <div class="nvSellerProfileCon11">
                  <div class="nvSellerProfileText3">Listados del perfil del vendedor</div>
                </div>
                <div class="nvSellerProfileCon14">
                  <div class="nvSellerProfileCon15">${listingsHtml}</div>
                </div>
              </div>
              <div class="nvSellerProfileCon10" style="display: ${proLevelDataDisp}">
                <div class="nvSellerProfileCon11">
                  <div class="nvSellerProfileText3">Negocio del vendedor</div>
                </div>
                <div class="nvSellerProfileCon12">${businessHtml}</div>
              </div>
            </div>
            <div class="nvSellerProfileCon16">
              <div class="nvSellerProfileCon18">
                <div class="nvSellerProfileCon19">
                  <div class="nvSellerProfileText6">Ver Perfil</div>
                   <img height="16px" src="${iconForward}">
                </div>
              </div>
            </div>
          </div>
        
    `
    let finalSellerHtml1 = sellerHtml;

    if (sellerLevel === 'gold' || sellerLevel === 'silver' || sellerLevel === 'reported') {
      finalSellerHtml1 = `
      <div class="sellersV2LevelCon1 ">
        <div class="sellersV2LevelCon2 ${sellerLevelBackgroundClass}">
          <div class="sellersV2LevelText1 ${sellerLevelText1Class}">${sellerLevelText1}</div>
          <div class="sellersV2LevelText2 ${sellerLevelText2Class}">${sellerLevelText2}</div>
        </div>
        <div class="sellersV2LevelCon3">${sellerHtml}</div>
      </div>
  `
    }

    let finalSellerHtml = `
        <div class="nvListingVerCon1A">${finalSellerHtml1}</div>
  `;

    return finalSellerHtml;

  }


  _NVSellerEach(data, businessHtml, listingsHtml) {

    const whatsAppNumber =
      (data.whatsAppNumberCountryCode + data.whatsAppNumber).replace(/\D/g, '');
    const phoneNumber =
      (data.callNumberCountryCode + data.callNumber).replace(/\D/g, '');


    let sellerLevel = data.sellerLevel || 'standart';
    sellerLevel = 'standart'; // just gaurd for now, to later get seller levels in place
    let proStatusClass = '';

    let about = data.aboutMe || 'Vendedor en Mercado MAI.';


    let profileImageUrl =
      data?.profileImages?.[0]?.res_200 ?? data?.profileImageUrl;

    let origImg = []
    origImg.push(data?.profileImages?.[0]?.res_1000 ?? data?.profileImageUrl)

    let listingsNum = data?.numberOfListings || 0;

    let sellerLevelBadgeHtml = ``

    let sellerLevelText1 = ''
    let sellerLevelText2 = ''
    let sellerLevelText1Class = ''
    let sellerLevelText2Class = ''


    if (sellerLevel === 'gold') {
      proStatusClass = 'sellerLevelGold';
      sellerLevelText1 = 'Vendedor nivel ORO'
      sellerLevelText2 = 'Mercado MAI recomienda este vendedor por publicar frecuentemente.'
    } else if (sellerLevel === 'silver') {
      proStatusClass = 'sellerLevelSilver';
      sellerLevelText1 = 'Vendedor nivel PLATA'
      sellerLevelText2 = 'Mercado MAI recomienda este vendedor por su esfuerzo de subir nuevas publicaciones.'
    } else if (sellerLevel === 'reported') {
      proStatusClass = 'sellerLevelReported';
      sellerLevelText1Class = 'sellerLevelReportedText1';
      sellerLevelText2Class = 'sellerLevelReportedText2';
      sellerLevelText1 = 'Vendedor REPORTADO'
      sellerLevelText2 = 'Mercado MAI no recomienda este vendedor por tener reportes negativos de nuestros usuarios.'
    }

    if (sellerLevel === 'gold' || sellerLevel === 'silver' || sellerLevel === 'reported') {
      sellerLevelBadgeHtml = `
        <div class="sellersV2LevelCon1A">
          <div class="sellersV2LevelCon2A ${proStatusClass}">
            <div class="sellersV2LevelText1 ${sellerLevelText1Class}">${sellerLevelText1}</div>
            <div class="sellersV2LevelText2 ${sellerLevelText2Class}">${sellerLevelText2}</div>
          </div>
        </div>
      `
    }



    return `
<div class="nvSellerEachCon1">
  <div class="nvSellerEachCon2">

      <div class="nvSellerEachCon4">
        <div class="BnvBusinessEachCon2 CloseCurrentStackPageButton">
          <div class="BnvBusinessEachCon3">
            <img height="20px" src="${iconBack}"/>
          </div>
        </div>
      </div>
      
      <div class="nvSellerEachCon5">
        <div class="nvSellerEachCon6">
          <div class="nvSellerEachCon7">
            <div class="nvSellerEachText1">${data.userName}</div>
          </div>
          <div class="nvSellerEachCon8">
            <div class="nvSellerProfileText4">${about}</div>
          </div>
        </div>
        <div class="nvSellerProfileCon3 ${proStatusClass}">
          <img data-origimg="${origImg.join("°-°|°-°?°-°|°-°")}" class="nvSellerProfileCon3Image ImgForBigDisplay hasOriginalImages" src="${profileImageUrl}">
        </div>
      </div>
  </div>

  ${sellerLevelBadgeHtml}

  <div id="nvSellerEachCon10ScrollCon" class="nvSellerEachCon10">
    <div class="nvSellerEachCon11">
      <div class="nvSellerEachCon11B">
        <div class="nvSellerEachCon11C">
          <div class="nvSellerEachText3">Datos sobre este vendedor</div>
        </div>
        <div class="nvSellerEachCon12">
          <div class="nvSellerProfileCon9">
            <div class="nvSellerProfileText4">Registrado desde</div>
            <div class="nvSellerProfileText5">${GENRALHELPERS._convertServerTimestampToReadableTime(data.createdAt, false)}</div>
          </div>
          <div class="nvSellerProfileCon9" style="display: none">
            <div class="nvSellerProfileText4">Publicaciones</div>
            <div class="nvSellerProfileText5">${listingsNum}</div>
          </div>
          <div class="nvSellerProfileCon9">
            <div class="nvSellerProfileText4">Numero de WhatsApp</div>
            <div class="nvSellerProfileText5">${data.callNumber}</div>
          </div>
          <div class="nvSellerProfileCon9">
            <div class="nvSellerProfileText4">Numero de llamadas</div>
            <div class="nvSellerProfileText5">${data.whatsAppNumber}</div>
          </div>
        </div>
      </div>
      <div class="nvListingEachCon14">

        <a class="nvListingEachCon16B" href="tel:${phoneNumber}">
          <div class="nvSellerEachText5">Llamar</div>
          <img height="18px" class="nvSellerEachCon4Image" src="${iconWhiteCall}">
        </a>

        <a class="nvSellerEachCon15" href="https://wa.me/${whatsAppNumber}?text=${encodeURIComponent('Te estoy contactando desde Mercado MAI')}" target="_blank" rel="noopener" >
          <div class="nvSellerEachText4">WhatsApp</div>
          <img height="18px" class="nvSellerEachCon4Image" src="${iconWhiteWhatsApp}">
        </a>

      </div>
    </div>
    <div class="nvSellerEachCon17">
      <div class="nvSellerEachCon18">
        <div class="nvSellerEachCon19">
          <div class="nvSellerEachText6">Empresas del vendedor</div>
        </div>
        <div id="nvSellerEachCon20InsertBusinesses" class="nvSellerEachCon20">${businessHtml}</div>
      </div>
      <div class="nvSellerEachCon21">
        <div class="nvSellerEachCon19">
          <div class="nvSellerEachText6">Listados del perfil del vendedor</div>
        </div>
        <div id="nvSellerEachCon22InsertListings"  class="nvSellerEachCon22">${listingsHtml}</div>
      </div>
    </div>
  </div>
</div>

  

    `;
  }
}

export default new generateHtml();
